import { Stack } from "@mui/material";

import ChangePasswordForm from "./ChangePasswordForm/ChangePasswordForm";
import FormTitle from "./FormTitle";

// ----------------------------------------------------------------------

export const OnboardingContent = () => {
	return (
		<Stack sx={{ justifyContent: "center", flexDirection: "row", alignItems: "center" }}>
			<Stack sx={{ width: { xs: "auto", sm: 400 } }}>
				<FormTitle />
				<ChangePasswordForm />
			</Stack>
		</Stack>
	);
};

export default OnboardingContent;
